/* file description */

import { Radio, Checkbox } from 'antd-mobile';
import React, { useRef, useState } from 'react';

export const RowSelectionLayout = (props) => {
  const { rowSelection, itemValue, rowKey, onEvents, listValues } = props;
  if (rowSelection?.type === 'radio') {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>
          <Radio
            key={itemValue[rowKey]}
            value={itemValue[rowKey]}
          />
        </div>
        {props.children}
      </div>
    );
  }

  if (rowSelection?.type === 'checkbox') {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>
          <Checkbox
            key={itemValue[rowKey]}
            value={itemValue[rowKey]}
            onChange={(val) => {
              if (rowSelection.onSelect) {
                rowSelection.onSelect(itemValue, val);
              }
            }}
          />
        </div>
        {props.children}
      </div>
    );
  }

  return (
    <>
      {props.children}
    </>
  );
};


export const RowSelectionBox = (props) => {
  const { rowSelection, rowKey, selectedRows, listValues } = props;

  const filterSelectValues = (targetKeys: string[]) => {
    return listValues?.filter((item) => {
      if (targetKeys.includes(item._id)) {
        return true;
      }
      return false;
    });
  };

  const radioChange = (v) => {
    const selValues = filterSelectValues([v]);
    rowSelection.onChange && rowSelection.onChange([v], selValues);
  };

  const checkboxChange = (v) => {
    const selValues = filterSelectValues(v);
    rowSelection.onChange && rowSelection.onChange(v, selValues);
  };

  if (rowSelection?.type === 'radio') {
    return (
      <Radio.Group value={rowSelection.selectedRowKeys?.[0] || null} onChange={radioChange}>
        {props.children}
      </Radio.Group>
    );
  }
  if (rowSelection?.type === 'checkbox') {
    return (
      <Checkbox.Group
        value={rowSelection.selectedRowKeys || selectedRows?.map((item) => item[rowKey]) || []}
        onChange={checkboxChange}
      >
        {props.children}
      </Checkbox.Group>
    );
  }
  return (
    <>
      {props.children}
    </>
  );
};
